import { createActions } from 'redux-actions';

const actions = createActions({
  BREED_MULTIBRAND_VALIDATION_FAILED: (data) => data,
  BREED_MULTIBRAND_VALIDATION_SUCCEED: (data) => data,
  GET_ORCA_POWER_UP: (data) => data,
  GET_ORCA_POWER_UPS_BATCH: (data) => data,
  ORCA_GET_POWER_UP_ATTEMPT: (data) => data,
  ORCA_GET_POWER_UP_BATCH_ITEM_ATTEMPT: (data) => data,
  ORCA_GET_POWER_UP_BATCH_ITEM_FAILED: (data) => data,
  ORCA_GET_POWER_UP_BATCH_ITEM_LOADED: (data) => data,
  ORCA_GET_POWER_UP_FAILED: (data) => data,
  ORCA_GET_POWER_UP_LOADED: (data) => data,
  RESET_VALIDATION_BREED_MULTIBRAND: (data) => data,
  VALIDATE_BREED_MULTIBRAND: (data) => data,
});

export const {
  breedMultibrandValidationFailed,
  breedMultibrandValidationSucceed,
  getOrcaPowerUp,
  getOrcaPowerUpsBatch,
  orcaGetPowerUpAttempt,
  orcaGetPowerUpBatchItemAttempt,
  orcaGetPowerUpBatchItemFailed,
  orcaGetPowerUpBatchItemLoaded,
  orcaGetPowerUpFailed,
  orcaGetPowerUpLoaded,
  resetValidationBreedMultibrand,
  validateBreedMultibrand,
} = actions;
